<template>
  <div class="instruments">
    <!-- <DIALOGS> -->
    <!-- <INSTRUMENT DELETE> -->
    <v-dialog v-model="deleteConfirmDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Da li ste sigurni da želiti izbrisati instrument?</v-card-title>

        <v-card-text>Svakom korisniku će biti izbrisana veza sa instrumentom ukoliko ga obrišete!</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" flat="flat" @click="deleteConfirmDialog = false">Prekini</v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="deleteInstrument(props.item.InstrumentId)"
          >Izbriši</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <INSTRUMENT DELETE> -->
    <!-- <INSTRUMENT CREATE OR UPDATE> -->
    <v-dialog v-model="cuDialog" width="850">
      <div style="background-color:white;">
        <instrument-c-u
          :isUpdate="isUpdate"
          :dialog="cuDialog"
          :instrumentId="selectedInstrument"
          @closeDialog="closeDialog"
          @addedOrChanged="addedOrChanged"
        ></instrument-c-u>
      </div>
    </v-dialog>
    <!-- </INSTRUMENT CREATE OR UPDATE> -->
    <!-- </DIALOGS> -->

    <img v-if="isLoading" class="loading-icon" src="../../assets/loading-icon.gif" alt="Loading...">
    <div class="header clearAfterFloats">
      <h2 class="title">
        <h1 class="header-text">
          <span>Instrumenti
            <div class="header-text-line"></div>
          </span>
        </h1>
      </h2>

      <!-- <INSTRUMENT SEARCH> -->
      <div class="instrument-search">
        <v-text-field class="search-field" v-model="searchText" label="Pretraga po nazivu"></v-text-field>

        <v-btn v-if="!isSearchActive" @click="filterByName" class="search-btn">
          <v-icon>search</v-icon>
          <span>Pretraga</span>
        </v-btn>

        <v-btn v-else @click="resetFilterObject" class="search-btn">
          <v-icon>close</v-icon>
          <span>Očisti pretragu</span>
        </v-btn>
      </div>
      <!-- </INSTRUMENT SEARCH> -->
      <img
        @click="cuDialog = true"
        src="../../assets/icons/create.png"
        class="action-icon-lg float-right"
        alt="Kreiraj"
      >
    </div>

    <!-- <INSTRUMENT DATA TABLE>-->
    <v-flex xs12>
      <v-data-table :headers="headers" :items="instruments" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.Name }}</td>
          <td class="text-xs-left">
            <div class="color-container" :style="{backgroundColor: props.item.Color}"></div>
          </td>
          <td class="text-xs-center">
            <img
              @click="setInstrumentForEdit(props.item.InstrumentId)"
              src="../../assets/icons/edit.png"
              class="action-icon-sm"
              alt="Uredi"
            >
            <img
              @click="setInstrumentForDelete(props.item.InstrumentId)"
              src="../../assets/icons/delete.png"
              class="action-icon-sm"
              alt="Uredi"
            >
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <!-- </INSTRUMENT DATA TABLE> -->
  </div>
</template>

<script>
import InstrumentCreateOrUpdate from "./CreateOrUpdate";
export default {
  components: {
    instrumentCU: InstrumentCreateOrUpdate
  },
  data() {
    return {
      //Data table headers
      headers: [
        {
          text: "Naziv",
          value: "naziv",
          align: "left"
        },
        {
          text: "Boja",
          value: "boja",
          align: "left"
        },
        {
          text: "Akcije",
          value: "akcije",
          align: "center"
        }
      ],
      instruments: [],
      //Dialogs
      cuDialog: false,
      deleteConfirmDialog: false,

      //Helpers
      isUpdate: false,
      selectedInstrument: 0,
      instrumentToDelete: 0,
      isLoading: false,
      isSearchActive: false,
      searchText: ""
    };
  },
  methods: {
    closeDialog() {
      this.cuDialog = false;
      this.isUpdate = false;
    },
    getInstruments() {
      this.isLoading = true;
      this.$store.state.services.instrumentService
        .getAll()
        .then(response => {
          this.instruments = response.data;
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    setInstrumentForEdit(selectedId) {
      this.selectedInstrument = selectedId;
      this.isUpdate = true;
      this.cuDialog = true;
    },
    setInstrumentForDelete(selectedId) {
      this.instrumentToDelete = selectedId;
      this.deleteConfirmDialog = true;
    },
    addedOrChanged(response) {
      this.getInstruments();
      this.closeDialog();
      this.$store.dispatch("setResponseMessage", response);
    },
    filterByName() {
      if (this.searchText == "") return;

      this.isSearchActive = true;
      this.isLoading = true;
      this.$store.state.services.instrumentService
        .filterByName(this.searchText)
        .then(response => {
          this.instruments = response.data;
          this.isLoading = false;
        });
    },
    resetFilterObject() {
      this.isSearchActive = false;
      this.searchText = "";

      this.getInstruments();
    },
    deleteInstrument() {
      this.deleteConfirmDialog = false;
      this.$store.state.services.instrumentService
        .remove(this.instrumentToDelete)
        .then(response => {
          this.getInstruments();
          this.$store.dispatch("setResponseMessage", response.data);
        });
    }
  },
  created() {
    this.getInstruments();
  },
  watch:{
    cuDialog(){
      if(this.cuDialog == false){
        this.isUpdate = false;
      }
    }
  }
};
</script>

<style scoped>
.instruments {
  padding: 10px 30px;
  position: relative;
}

.title {
  width: 30%;
  float: left;
  font-size: 28px;
  color: #030405;
}

.instrument-search {
  width: 50%;
  float: left;
}

.search-field {
  width: 60%;
  float: left;
}

.search-btn {
  float: left;
  margin-left: 20px;
}

.color-container {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
</style>
